<template>
  <div>
    <a-modal
      v-model="visibleControlColumnsModal"
      :title="selectedRowKeys.length ? 'Pola do eksportu' : 'Widoczne pola'"
      width="560px"
    >
      <invoiceTableTransfer
        :controlTableColumns="controlTableColumns"
        ref="invoiceTableTransfer"
      />
      <template slot="footer">
        <a-row type="flex" justify="space-between">
          <div>
            <a-button
              type="primary"
              icon="save"
              @click="handlerSaveReport"
              style="margin-right: 15px"
            />
            <a-auto-complete
              v-model="reportInputValue"
              :data-source="Object.keys(info.reportSales.sales)"
              style="width: 200px; border-radius: 0; margin-right: 15px"
              placeholder="Nazwa raportu"
              @select="handlerSelectReport"
            />
            <a-button
              type="danger"
              icon="delete"
              @click="handlerDeleteReport"
            />
          </div>
          <div>
            <a-tooltip
              title="Ustaw jako domyślne dla wszystkich"
              v-if="profile.ADMIN"
            >
              <a-switch
                :checked="isAdminOptionChecked"
                @change="(val) => (isAdminOptionChecked = val)"
              >
                <a-icon slot="checkedChildren" type="check" />
                <a-icon slot="unCheckedChildren" type="close" />
              </a-switch>
            </a-tooltip>
            <a-button
              key="submit"
              type="primary"
              @click="handlerReportModalSubmit"
              >{{ $t(selectedRowKeys.length ? $t("Export") : $t("Save")) }}</a-button
            >
          </div>
        </a-row>
      </template>
    </a-modal>
    <a-layout
      id="salesTable"
      v-show="!visibleSteps"
      style="background: #ffffff"
    >
      <a-layout-header
        style="
          background: #ffffff;
          margin-bottom: 25px;
          margin-top: 5px;
          padding: 0px;
          line-height: 0px;
          height: auto;
        "
      >
        <a-row type="flex" justify="space-between" align="middle">
          <a-button
            :disabled="this.addnew == 0"
            type="primary"
            icon="form"
            @click="goSteps(record)"
            style="margin-right: 15px"
          />
          <a-button
            type="primary"
            @click="
              () => {
                this.visibleControlColumnsModal = true;
              }
            "
            :disabled="!selectedRowKeys.length"
            style="margin-right: 15px"
            icon="file-excel"
            :loading="uploading"
          />

          <a-col style="flex: 1; margin-right: 15px" class="search-wrapper">
            <a-dropdown :trigger="['click']">
              <a-input-search
                class="ant-dropdown-link"
                @search="() => handleSearch()"
                v-model="searchlabel"
                :placeholder="$t('Search by name')"
              />
              <a-menu slot="overlay" style="background-color: #fafafa">
                <a-form
                  :form="form"
                  id="my_form_search_styl"
                  layout="vertical"
                  style="padding: 15px"
                >
                  <a-menu-item key="1">
          
                

                    <a-form-item :label='$t("Kontrahent")' hidden>
                      <a-select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        v-decorator="[
                          'kontragent',
                          {
                            rules: [{ required: false }],
                            initialValue:
                              placementCompanyID === false
                                ? ''
                                : placementCompanyID,
                          },
                        ]"
                      >
                        <!--<a-select-option
                          v-for="comp in info.company"
                          :key="comp.ID"
                          >{{ comp.TITLE }}</a-select-option
                        >-->
                      </a-select>
                    </a-form-item>
                  </a-menu-item>

                  <a-menu-item key="10">

                   <a-form-item :label='$t("Kontrahent")' >
                        <a-input               
                          @click="handleChangeContractor()"
                          v-model="contractorTitle"
                        />
                    </a-form-item>
                  </a-menu-item>

                

                  <a-menu-item key="9">
                    <a-form-item :label="$t('Status')">
                      <a-select
                        allowClear
                        mode="multiple"
                        optionFilterProp="children"
                        v-decorator="[
                          'status',
                          { rules: [{ required: false }], initialValue: [] },
                        ]"
                      >
                        <template v-for="item in statusList">
                          <a-select-option :key="item.name">{{
                            $t(item.name)
                          }}</a-select-option>
                        </template>
                      </a-select>
                    </a-form-item>
                  </a-menu-item>
                  <a-menu-item key="10">
                    <a-form-item :label='$t("Rodzaj przychodu")'>
                      <a-select
                        showSearch
                        allowClear
                        mode="multiple"
                        optionFilterProp="children"
                        v-decorator="[
                          'rodzaj',
                          { rules: [{ required: false }], initialValue: [] },
                        ]"
                      >
                        <a-select-option key="FVS PPC Audyt"
                          >FVS PPC Audyt</a-select-option
                        >
                        <a-select-option key="FVS CM Tworzenie Tresci"
                          >FVS CM Tworzenie Tresci</a-select-option
                        >
                        <a-select-option key="FVS PPC FB Marza"
                          >FVS PPC FB Marza</a-select-option
                        >
                        <a-select-option key="FVS PPC Analityka"
                          >FVS PPC FB Analityka</a-select-option
                        >
                        <a-select-option key="FVS PPC AdWords Media"
                          >FVS PPC AdWords Media</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-menu-item>
                  <a-menu-item key="11">
                    <a-form-item :label='$t("Rodzaj")'>
                      <a-select
                        allowClear
                        showSearch
                        mode="multiple"
                        optionFilterProp="children"
                        v-decorator="[
                          'typFaktury',
                          { rules: [{ required: false }], initialValue: [] },
                        ]"
                      >
                        <a-select-option value="Faktura">{{ $t('Faktura Kosztowa') }}</a-select-option>
                        <a-select-option value="Proforma">{{ $t('Proforma') }}</a-select-option>
                        <a-select-option value="VAT Marza">{{ $t('Faktura do Proformy') }}</a-select-option>
                        <a-select-option value="Korekta">{{ $t('Korygująca') }}</a-select-option>
                        <a-select-option value="Faktura zaliczkowa"
                          >{{ $t('Faktura zaliczkowa') }}</a-select-option
                        >
                        <a-select-option value="Faktura koncowa"
                          >{{ $t('Faktura koncowa') }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-menu-item>
                  <a-menu-item key="12">
                    <a-form-item :label="$t('Project')">
                      <a-select
                        allowClear
                        showSearch
                        mode="multiple"
                        optionFilterProp="children"
                        v-decorator="[
                          'project',
                          {
                            rules: [{ required: false }],
                            initialValue:
                              placementDealID === false
                                ? []
                                : [placementDealID],
                          },
                        ]"
                      >
                        <a-select-option v-for="item in DEAL" :key="item.ID">{{
                          item.TITLE
                        }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-menu-item>

                  <a-menu-item key="11">

                   <a-form-item :label='$t("CompanyName")' >
                        <a-input               
                          @click="handleChangeMyCompany()"
                          v-model="companyTitle"
                        />
                    </a-form-item>
                  </a-menu-item>

                  <a-menu-item key="8" hidden>
                    <a-form-item :label="$t('CompanyName')">
                      <a-select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        v-decorator="[
                          'spolka',
                          { rules: [{ required: false }], initialValue: '' },
                        ]"
                      >
                        <a-select-option
                          v-for="comp in info.company"
                          :key="comp.ID"
                          >{{ comp.TITLE }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-menu-item>
                  <a-menu-item key="2">
                    <a-form-item :label='$t("Termin płatności")'>
                      <a-range-picker
                        allowClear
                        v-decorator="[
                          'terminPlatnosci',
                          {
                            rules: [{ type: 'array', required: false }],
                            initialValue: [],
                          },
                        ]"
                      />
                    </a-form-item>
                  </a-menu-item>
                  <a-menu-item key="7">
                    <a-form-item :label='$t("Przypomnienie")'>
                      <a-range-picker
                        allowClear
                        v-decorator="[
                          'przypomnienie',
                          {
                            rules: [{ type: 'array', required: false }],
                            initialValue: [],
                          },
                        ]"
                      />
                    </a-form-item>
                  </a-menu-item>
                  <a-menu-item key="3">
                    <a-form-item :label="$t('Data usługi')">
                      <a-range-picker
                        allowClear
                        v-decorator="[
                          'dataUslugi',
                          {
                            rules: [{ type: 'array', required: false }],
                            initialValue: [],
                          },
                        ]"
                      />
                    </a-form-item>
                  </a-menu-item>
                  <a-menu-item key="4">
                    <a-form-item :label='$t("Data sprzedaży")'>
                      <a-range-picker
                        allowClear
                        v-decorator="[
                          'dataSprzedazy',
                          {
                            rules: [{ type: 'array', required: false }],
                            initialValue: [],
                          },
                        ]"
                      />
                    </a-form-item>
                  </a-menu-item>
                  <a-menu-item key="5">
                    <a-form-item :label='$t("Data wystawienia")'>
                      <a-range-picker
                        allowClear
                        v-decorator="[
                          'dataWystawienia',
                          {
                            rules: [{ type: 'array', required: false }],
                            initialValue: [],
                          },
                        ]"
                      />
                    </a-form-item>
                  </a-menu-item>
                  <a-menu-item key="6">
                    <a-form-item
                      style="text-align: center"
                      :label-col="{ span: 0 }"
                      :wrapper-col="{ span: 24 }"
                    >
                      <a-button type="primary" @click="() => handleSearch()">{{
                        $t("Search")
                      }}</a-button>
                      <a-button
                        @click="handleReset()"
                        style="margin-left: 50px"
                        >{{ $t("Reset") }}</a-button
                      >
                    </a-form-item>
                  </a-menu-item>
                </a-form>
              </a-menu>
            </a-dropdown>
          </a-col>
          <a-button
            type="primary"
            :icon="iconCheck"
            @click="!iconCheck ? handleSearchArch() : handleReset()"
            style="margin-right: 15px"
            >{{ $t("Archiwum") }}</a-button
          >
          <a-col>
            <a-button
              type="primary"
              icon="control"
              @click="() => (visibleControlColumnsModal = true)"
            />
          </a-col>
        </a-row>
      </a-layout-header>
      <a-layout-content>
        <a-table
          :columns="tableColumns.selected"
          :dataSource="dataSource"
          :pagination="{
            'show-size-changer': true,
            showTotal: (total) => `${this.$t('Total')} ${total}`,
          }"
          style="background: #ffffff"
          @change="handleTableChange"
          size="middle"
          tableLayout="auto"
          :scroll="{ x: true }"
          :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChangeTable,
          }"
          bordered
        >
          <template
            slot="numerfaktury"
            slot-scope="text, record"
            style="text-align: left"
          >
            <a-button
              @click="goSteps(record)"
              type="link"
              style="white-space: normal; text-align: left"
              >{{ text }}</a-button
            >
          </template>
          <template slot="preview" slot-scope="text, record, index">
            <a-button
              @click="previewFile(record)"
              :loading="loading"
              type="link"
              icon="eye"
            />
            <a-button
              icon="download"
              type="link"
              @click="downloadFile(record)"
              :loading="loading"
              style="color: #62bb45"
            ></a-button>
            <a-button
              v-if=addnew
              @click="deleteFile(record, index)"
              :loading="loading"
              type="link"
              icon="delete"
              :style="{color: checkResponsible ? '#ff4d4f' : '#949494'}"
              :disabled="!checkResponsible"
            />
          </template>
        </a-table>
        <statisticFromStatus
          :handleSearch="handleSearch"
          :statusList="statusList"
        />
      </a-layout-content>
    </a-layout>
    <saleSteps
      v-if="visibleSteps"
      :info="info"
      :user_setup="user_setup"
      :sale_record="sale_record"
      :current="current"
      :profile="profile"
      :checkMedia="checkMedia"
      :checkMediaInvoice="checkMediaInvoice"
      :fieldColumns="tableColumns.all"
      :disableFromResponsible="disableFromResponsible"
      :COMPANY_LIST="COMPANY_LIST"
      :MY_COMPANY_LIST="MY_COMPANY_LIST"
      :USER_LIST="USER_LIST"
      :VAT_LIST="VAT_LIST"
      :DEAL="DEAL"
      :dataSales="dataSales"
      @onBackMedia="onBackMedia"
      @back="onback"
      @ReturnToStepBack="handleReturnToStepBack"
      @changeSpinning="changeSpinning"
      @onClose="onClose"
      @goSteps="goSteps"
    />
    <a-drawer
      title="Podgląd Prev"
      :visible="visiblePoglad"
      @close="onClosePoglad"
      width="60%"
    >
      <a-spin :spinning="prew_doc_spinner" style="flex: 1">
        <div style="margin: 25px">
          <span v-if="!prew_doc">
            <div v-if="docPdf" style="width: fit-content">
              <canvas id="the_canvas_detail_table" style="display: none" />
              <div
                style="display: flex; justify-content: space-between"
                v-if="!prew_doc_spinner"
              >
                <a-button
                  :disabled="currentPage - 1 < 1 ? true : false"
                  @click="
                    () => {
                      currentPage--;
                      getpdf('the_canvas_detail_prev');
                    }
                  "
                >
                  <a-icon type="left" />
                  {{ $t("Prev") }}
                </a-button>
                <span>{{ currentPage }} / {{ countPages }}</span>
                <a-button
                  :disabled="currentPage + 1 > countPages ? true : false"
                  @click="
                    () => {
                      currentPage++;
                      getpdf('the_canvas_detail_prev');
                    }
                  "
                >
                  {{ $t("Next") }}
                  <a-icon type="right" />
                </a-button>
              </div>
            </div>
          </span>
          <a-empty v-else />
        </div>
      </a-spin>
    </a-drawer>
  </div>
</template>

<script>
import saleSteps from "./sales_steps.vue";
import invoiceTableTransfer from "./invoiceTableTransfer";
import moment from "moment";
import {
  getAllCreatingInvoice,
  getSalesAllStage,
  returnToStepBackSale,
  getExcelSales,
  saveReports,
  getFilterSales,
} from "@/requestFunc";
import statisticFromStatus from "./statisticFromStatus";
import { mapMutations } from "vuex";
var pdfjsLib = require("pdfjs-dist/build/pdf");
var pdfjsWorker = require("pdfjs-dist/build/pdf.worker.entry");
export default {
  components: {
    saleSteps,
    invoiceTableTransfer,
    statisticFromStatus,
  },
  props: [
    "COMPANY_LIST",
    "user_setup",
    "MY_COMPANY_LIST",
    "USER_LIST",
    "VAT_LIST",
    "info",
    "placementDealID",
    "placementCompanyID",
    "checkMedia",
    "dataSales",
    "checkMediaInvoice",
    "invoiceMedia",
    "responsible"
  ],
  data() {
    return {
      countPages: 1,
      currentPage: 1,
      visibleControlColumnsModal: false,
      current: 0,
      searchlabel: "",
      DEAL: [],
      lastkey: 0,
      prew_doc_spinner: true,
      prew_doc: false,
      visiblePoglad: false,
      disableFromResponsible: false,
      dataSource: [],
      addnew: 0,
      onlyAdm: 0,
      loading: false,
      domain: "",
      docPdf: true,
      contractorTitle: "",
      companyTitle: "",
      iconCheck: undefined,
      isAdminOptionChecked: false,
      reportInputValue: "",
      visibleSteps: false,
      pdfUrlMachine: "",
      profile: [],
      userProfile: {},
      uploading: false,
      selectedRowKeys: [],
      form: this.$form.createForm(this, { name: "search" }),
      sale_record: {},
      statusList: [
        { name: "Nowy", color: "#029C8E" },
        { name: "Oczekujacy", color: "#029C8E" },
        { name: "Zaakceptowany", color: "#2C7FE4" },
        { name: "Czesciowo Splacony", color: "#FCB76F" },
        { name: "Splacony", color: "#FCB76F" },
      ],
      controlTableColumns: {
        plainOptions: [],
        checkedList: [
          "Numer faktury",
          "Opis",
          "Waluta",
          "Zmiana czasu",
          "Status",
        ],
      },
      tableColumns: {
        selected: [],
        all: [
          {
            title: this.$t("Opis"),
            dataIndex: "description",
            sorter: (a, b) => this.sortField(a.description, b.description),
          },
          {
            title: this.$t("Kontrahent"),
            ellipsis: true,
            dataIndex: "contractor",
            sorter: (a, b) =>
              this.sortField(a.contractor, b.contractor, (x) =>
                x && this.COMPANY_LIST[x] ? this.COMPANY_LIST[x]["TITLE"] : ""
              ),
            customRender: (text) => {
              if (text && this.COMPANY_LIST[text]) {
                return (
                  <a
                    href={`https://${this.domain}/crm/company/details/${text}/`}
                    target="_blank"
                  >
                    {this.COMPANY_LIST[text]["TITLE"]}
                  </a>
                );
              }
              return "";
            },
          },
          {
            title: this.$t("Spółka"),
            ellipsis: true,
            dataIndex: "company",
            sorter: (a, b) =>
              this.sortField(a.company, b.company, (x) =>
                x && this.COMPANY_LIST[x] ? this.COMPANY_LIST[x]["TITLE"] : ""
              ),
            customRender: (text) => {
              if (text && this.COMPANY_LIST[text]) {
                return (
                  <a
                    href={`https://${this.domain}/crm/company/details/${text}/`}
                    target="_blank"
                  >
                    {this.COMPANY_LIST[text]["TITLE"]}
                  </a>
                );
              }
              return "";
            },
          },
          {
            title: this.$t("Dni po terminie"),
            dataIndex: "expiredDay",
            sorter: (a, b) =>
              this.sortField(a.dueDate, b.dueDate, (x) =>
                x
                  ? Math.floor(
                      (Date.parse(new Date()) - Date.parse(x)) / 86400000
                    )
                  : ""
              ),
            customRender: (text, record) => {
              if (text) {
                return Math.floor(
                  (Date.parse(new Date()) - Date.parse(record.dueDate)) /
                    86400000
                );
              } else {
                return "";
              }
            },
          },
          {
            title: this.$t("Vat"),
            dataIndex: "vat",
            sorter: (a, b) => this.sortField(a.vat, b.vat, (x) => (x ? +x : 0)),
          },
          {
            title: this.$t("Opłacony"),
            dataIndex: "amountPaid",
            sorter: (a, b) => this.sortField(a.vat, b.vat, (x) => (x ? +x : 0)),
          },
          {
            title: this.$t("Netto"),
            dataIndex: "netto",
            sorter: (a, b) =>
              this.sortField(a.netto, b.netto, (x) => (x ? +x : 0)),
          },
          {
            title: this.$t("Brutto"),
            dataIndex: "totalAmout",
            sorter: (a, b) =>
              this.sortField(a.totalAmout, b.totalAmout, (x) => (x ? +x : 0)),
          },
          {
            title: this.$t("Project"),
            dataIndex: "project",
            sorter: (a, b) =>
              this.sortField(a.project, b.project, (x) => {
                if (x) {
                  let kk = this.DEAL.find((el) => x == el.ID);
                  return kk ? kk.TITLE : "";
                }
                return "";
              }),
            customRender: (text) => {
              let kk = this.DEAL.find((el) => text == el.ID);
              if (text && kk) {
                return (
                  <a
                    href={`https://${this.domain}/crm/deal/details/${kk.ID}/`}
                    target="_blank"
                  >
                    {kk.TITLE}
                  </a>
                );
              }
              return "";
            },
          },
          {
            title: this.$t("Wysłane maile"),
            dataIndex: "countMail",
            sorter: (a, b) =>
              this.sortField(a.countMail, b.countMail, (x) => (x ? +x : 0)),
          },
          {
            title: this.$t("Opiekun"),
            dataIndex: "responsible",
            sorter: (a, b) =>
              this.sortField(a.responsible, b.responsible, (x) =>
                x
                  ? `${this.USER_LIST[x].NAME} ${this.USER_LIST[x].LAST_NAME}`
                  : ""
              ),
            customRender: (text) => {
              if (text) {
                let user = this.USER_LIST[text];
                return user ? `${user.NAME} ${user.LAST_NAME}` : "";
              }
              return "";
            },
          },
          {
            title: this.$t("Konto bankowe"),
            dataIndex: "bankAccount",
            sorter: (a, b) => this.sortField(a.bankAccount, b.bankAccount),
          },
          {
            title: this.$t("Data wystawienia"),
            dataIndex: "billingDate",
            sorter: (a, b) =>
              this.sortField(a.billingDate, b.billingDate, (x) =>
                x ? new Date(x) : ""
              ),
          },
          {
            title: this.$t("Termin płatności"),
            dataIndex: "dueDate",
            sorter: (a, b) =>
              this.sortField(a.dueDate, b.dueDate, (x) =>
                x ? new Date(x) : ""
              ),
          },
          {
            title: this.$t("Rodzaj"),
            dataIndex: "invoiceType",
            sorter: (a, b) => this.sortField(a.invoiceType, b.invoiceType),
          },
          {
            title: this.$t("Język"),
            dataIndex: "language",
            sorter: (a, b) => this.sortField(a.language, b.language),
          },
          {
            title: this.$t("Płatność"),
            dataIndex: "paymentType",
            sorter: (a, b) => this.sortField(a.paymentType, b.paymentType),
          },
          {
            title: this.$t("Przypomnienie"),
            dataIndex: "reminder",
            sorter: (a, b) =>
              this.sortField(a.reminder, b.reminder, (x) =>
                x ? new Date(x) : ""
              ),
          },
          {
            title: this.$t("Waluta"),
            dataIndex: "currency",
            sorter: (a, b) => this.sortField(a.currency, b.currency),
          },
          {
            title: this.$t("Date of change"),
            dataIndex: "timeChange",
            sorter: (a, b) =>
              this.sortField(a.timeChange, b.timeChange, (x) =>
                x ? new Date(x) : ""
              ),
          },
          {
            title: this.$t("Data usługi"),
            dataIndex: "serviceDate",
            sorter: (a, b) =>
              this.sortField(a.serviceDate, b.serviceDate, (x) =>
                x ? new Date(x) : ""
              ),
          },
          {
            title: this.$t("Data sprzedaży"),
            dataIndex: "saleDate",
            sorter: (a, b) =>
              this.sortField(a.saleDate, b.saleDate, (x) =>
                x ? new Date(x) : ""
              ),
          },
          /* {
            title: this.$t("Date of booking"),
            dataIndex: "publicationDate",
            sorter: (a, b) =>
              this.sortField(a.publicationDate, b.publicationDate, (x) =>
                x ? new Date(x) : ""
              ),
          },
          {
            title: "Kwota",
            dataIndex: "amount",
            sorter: (a, b) =>
              this.sortField(a.amount, b.amount, (x) => (x ? +x : 0)),
          },*/
          {
            title: this.$t("Notatka"),
            dataIndex: "comment",
            sorter: (a, b) => this.sortField(a.Notatka, b.Notatka),
          },
        ],
      },
      checkResponsible: false
    };
  },
  methods: {
    ...mapMutations(["updateStatisticNumber", "setStatistic"]),
    onBackMedia(data) {
      this.$emit("onBackMedia", data);
    },
    handleChangeMyCompany() {
      BX24.selectCRM({
        entityType: ['company'],
        multiple: true,
      }, (info) => {
        let arrayCompanyName = [];
        let arrayCompanyID = [];
        for (let name in info.company) {
          arrayCompanyName.push(info.company[name].title);
          arrayCompanyID.push(info.company[name].id.split("_")[1]);
        }
        this.companyTitle = arrayCompanyName.join();
        this.form.setFieldsValue({
            spolka: arrayCompanyID,
          });
      })
    },
    handleChangeContractor() {
      BX24.selectCRM({
        entityType: ['company'],
        multiple: true,
      }, (info) => {
        let arrayCompanyName = [];
        let arrayCompanyID = [];
        for (let name in info.company) {
          arrayCompanyName.push(info.company[name].title);
          arrayCompanyID.push(info.company[name].id.split("_")[1]);
        }
        this.contractorTitle = arrayCompanyName.join();
        this.form.setFieldsValue({
            kontragent: arrayCompanyID,
          });
      })
    },
    handleSearch(params) {
 
      if (params) {
        this.filterInfo = params;
      } else {
        this.form.validateFields((err, values) => {

          values["title"] = this.searchlabel;
          values["dataWystawienia"] = values.dataWystawienia.length
            ? [
                moment(values.dataWystawienia[0]).format("YYYY-MM-DD"),
                moment(values.dataWystawienia[1]).format("YYYY-MM-DD"),
              ]
            : undefined;

          values["terminPlatnosci"] = values.terminPlatnosci.length
            ? [
                moment(values.terminPlatnosci[0]).format("YYYY-MM-DD"),
                moment(values.terminPlatnosci[1]).format("YYYY-MM-DD"),
              ]
            : undefined;

          values["przypomnienie"] = values.przypomnienie.length
            ? [
                moment(values.przypomnienie[0]).format("YYYY-MM-DD"),
                moment(values.przypomnienie[1]).format("YYYY-MM-DD"),
              ]
            : undefined;

          values["dataUslugi"] = values.dataUslugi.length
            ? [
                moment(values.dataUslugi[0]).format("YYYY-MM-DD"),
                moment(values.dataUslugi[1]).format("YYYY-MM-DD"),
              ]
            : undefined;
          values["dataSprzedazy"] = values.dataSprzedazy.length
            ? [
                moment(values.dataSprzedazy[0]).format("YYYY-MM-DD"),
                moment(values.dataSprzedazy[1]).format("YYYY-MM-DD"),
              ]
            : undefined;

          this.filterInfo = values;

        });
      }
      if (
        $(".ant-dropdown-placement-bottomLeft").css("display") != "none" &&
        $(".ant-dropdown-placement-bottomLeft").css("display") != undefined
      ) {
        $(".search-wrapper input").click();
      }
      this.changeSpinning(true);
      getFilterSales("invoice", this.filterInfo)
        .done((data) => {
          this.dataSource = JSON.parse(data);

        })
        .fail((e) => {
          console.err(e);
          this.$message.error(this.$t("Error loading files"));
        })
        .always(() => {
          this.changeSpinning(false);
        });
    },
    handleSearchArch() {
      this.form.validateFields((err, values) => {
        this.changeSpinning(true);
        this.iconCheck = "check";
        values["status"] = "Splacony";
        this.filterInfo = values;

        getFilterSales("invoice", values)
          .done((data) => {

            this.dataSource = JSON.parse(data);
            this.resize();
            this.$message.success("Filter ok");
          })
          .fail((e) => {
            console.err(e);
            this.$message.error(this.$t("Error loading files"));
          })
          .always(() => {
            this.changeSpinning(false);
          });
      });
    },
    handleReset() {
      this.form.validateFields((err, values) => {
        if (
          $(".ant-dropdown-placement-bottomLeft").css("display") != "none" &&
          $(".ant-dropdown-placement-bottomLeft").css("display") != undefined
        ) {
          $(".search-wrapper input").click();
        }
        this.changeSpinning(true);
        this.form.resetFields();
        this.filterInfo = undefined;
        this.contractorTitle = "";
        this.companyTitle = "";
        this.sortedInfo = { sort_column: undefined, sort_order: undefined };
        this.iconCheck = undefined;
        values["status"] = [
          "Czesciowo Splacony",
          "Oczekujacy",
          "Zaakceptowany",
          "Nowy",
        ];
        getFilterSales("invoice", values)
          .done((data) => {
            let elem = JSON.parse(data);
            this.dataSource = elem;
            this.$message.success("Reset filter ok");
          })
          .fail((e) => {
            console.err(e);
            this.$message.error(this.$t("Error loading files"));
          })
          .always(() => {
            this.changeSpinning(false);
          });
      });
    },
    handlerReportModalSubmit() {
      this.changeSpinning(true);
      if (this.selectedRowKeys.length) {
        this.handleGetExcel();
      } else {
        this.updateSelectedColumns();
      }
      this.visibleControlColumnsModal = false;
      this.changeSpinning(false);
    },
    updateSelectedColumns() {
      let kk = [];
      for (let item of this.controlTableColumns.checkedList) {
        let f = this.tableColumns.all.find((x) => x.title == item);
        if (f) kk.push(f);
      }

      this.tableColumns.selected = kk;

      BX24.userOption.set(
        "userTableColumnsSales",
        JSON.stringify(this.controlTableColumns.checkedList)
      );
      if (this.isAdminOptionChecked) {
        BX24.appOption.set(
          "adminTableColumnsSales",
          JSON.stringify(this.controlTableColumns.checkedList)
        );
        this.$message.success(this.$t("List of default fields for all"));
      }

      this.tableColumns.selected = [
        {
          title: this.$t("Numer"),
          dataIndex: "invoiceAutoNumber",
          sorter: (a, b) =>
            this.sortField(a.invoiceAutoNumber, b.invoiceAutoNumber),
        },
        {
          title: this.$t("Numer faktury"),
          dataIndex: "invoiceTitle",
          sorter: (a, b) => this.sortField(a.invoiceTitle, b.invoiceTitle),
          scopedSlots: { customRender: "numerfaktury" },
        },
        ...this.tableColumns.selected,
        {
          title: this.$t("Status"),
          align: "center",
          fixed: "right",
          width: 150,
          dataIndex: "status",
          customRender: (text) => {
            let status = this.statusList.find((x) => x.name == text);
            return status ? (
              <a-tag color={status.color}>{this.$t(status.name)}</a-tag>
            ) : (
              <a-tag color={"#3C494F"}>{this.$t(text)}</a-tag>
            );
          },
        },
        {
          title: this.$t("Actions"),
          dataIndex: "docID",
          align: "center",
          width: 150,
          fixed: "right",
          scopedSlots: { customRender: "preview" },
        },
      ];
    },
    onSelectChangeTable(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;

    },
    handlerSaveReport() {
      this.info.reportSales.sales[
        this.reportInputValue
      ] = this.tableColumns.all
        .filter((x) => this.controlTableColumns.checkedList.includes(x.title))
        .map((x) => x.dataIndex);

      saveReports("sales", this.info.reportSales.sales).always((res) => {
        if (res == "success") {
          this.$message.success(this.reportInputValue + ' ' + this.$t("report saved"));
        } else {
          this.$message.error(
            this.$t("Error report save")
          );
        }

      });
    },
    handlerSelectReport(name) {
      this.controlTableColumns.checkedList = this.tableColumns.all
        .filter((x) => this.info.reportSales.sales[name].includes(x.dataIndex))
        .map((x) => x.title);
      this.$refs.invoiceTableTransfer.getMock();
    },
    handlerDeleteReport() {
      delete this.info.reportSales.sales[this.reportInputValue];
      this.reportInputValue = "";
      saveReports("sales", this.info.reportSales.sales).always((res) => {
        if (res == "success") {
          this.$message.success(this.reportInputValue + ' ' +  this.$t("report deleted"));
        } else {
          this.$message.error(
            this.$t("Error report delete")
          );
        }
      });
    },
    handleGetExcel() {
      this.uploading = true;
      var files_for_export = this.dataSource
        .filter((x) => this.selectedRowKeys.includes(x.key))
        .map((x) => x.ID);

      var columns_export = [
        "invoiceAutoNumber",
        "invoiceTitle",
        ...this.tableColumns.all
          .filter((x) => this.controlTableColumns.checkedList.includes(x.title))
          .map((x) => x.dataIndex),
      ];

      getExcelSales(files_for_export, columns_export)
        .done((req) => {

          let res = JSON.parse(req);

          var link = document.createElement("a");
          link.setAttribute("href", res.link);
          link.setAttribute("download", "download.xlsx");
          onload = link.click();
        })
        .fail(() => {

        })
        .always(() => {
          this.uploading = false;
        });
    },
    handleReturnToStepBack() {
      this.changeSpinning(true);
      var prev = this.sale_record.status;
      var next = this.sale_record.status;

      returnToStepBackSale(this.sale_record.ID, this.sale_record.status)
        .done((data) => {
          var res = JSON.parse(data);
          this.sale_record.status = res.status;
          next = res.status;

          this.$message.success(this.$t("Back to description"));
        })
        .fail((e) => console.err(e))
        .always(() => {
          this.changeSpinning(false);
          this.onClose(prev != next && { prev, next });
          this.resize();
          this.goSteps(this.sale_record);
        });
    },
    downloadFile(record) {

      this.loading = true;
      if (record.docID) {
        BX24.callMethod(
          "crm.documentgenerator.document.get",
          { id: record.docID },
          (result) => {
            // eslint-disable-next-line
            if (result.error()) {}
            else {
              this.resultGetDoc = result.data();
              if (
                this.resultGetDoc.document.pdfUrlMachine != undefined &&
                this.resultGetDoc.document.pdfUrlMachine != null
              ) {
                this.pdfUrlMachine = this.resultGetDoc.document.pdfUrlMachine;
                var link = document.createElement("a");
                link.setAttribute("href", this.pdfUrlMachine);
                link.setAttribute("download", "download");
                onload = link.click();
                this.loading = false;
              } else {
                this.timerId = setInterval(() => {
                  BX24.callMethod(
                    "crm.documentgenerator.document.get",
                    { id: record.ID },
                    (result) => {
                      // eslint-disable-next-line
                      if (result.error()) {}
                      else {
                        this.resultGetDoc = result.data();
                        if (
                          this.resultGetDoc.document.pdfUrlMachine &&
                          this.resultGetDoc.document.pdfUrlMachine
                        ) {
                          this.pdfUrlMachine = this.resultGetDoc.document.pdfUrlMachine;
                          var link = document.createElement("a");
                          link.setAttribute("href", this.pdfUrlMachine);
                          link.setAttribute("download", "download");
                          onload = link.click();
                          this.loading = false;
                          clearInterval(this.timerId);
                        }
                      }
                    }
                  );
                }, 5000);
              }
            }
          }
        );

      } else {
        this.loading = false;
        this.$message.info(this.$t("Nie znaleziono pliku!"));
      }
    },
    deleteFile(record, index) {

      this.loading = true;
      if (record.ID) {
        BX24.callMethod(
          "entity.item.delete",
          {
            ENTITY: "invoices",
            ID: record.ID,
          },
          (result) => {
            if (result.error()) console.error(result.error());
            else {
              this.dataSource.splice(index, 1);
              this.loading = false;
            }
          }
        );
      } else {
        this.loading = false;
        this.$message.info(this.$t("Nie znaleziono pliku!"));
      }
    },
    showDrawerPoglad() {
      this.visiblePoglad = true;
      this.getpdf("the_canvas_detail_table");
    },
    onClosePoglad() {
      this.visiblePoglad = false;
    },
    previewFile(record) {
      this.loading = true;

      if (record.docID) {
        BX24.callMethod(
          "crm.documentgenerator.document.get",
          { id: record.docID },
          (result) => {
            // eslint-disable-next-line
            if (result.error()) {}
            else {
              this.resultGetDoc = result.data();
              if (
                this.resultGetDoc.document.pdfUrlMachine != undefined &&
                this.resultGetDoc.document.pdfUrlMachine != null
              ) {
                this.pdfUrlMachine = this.resultGetDoc.document.pdfUrlMachine;
                this.showDrawerPoglad();
              } else {
                this.timerId = setInterval(() => {
                  BX24.callMethod(
                    "crm.documentgenerator.document.get",
                    { id: record.docID },
                    (result) => {
                      // eslint-disable-next-line
                      if (result.error()) {}
                      else {
                        this.resultGetDoc = result.data();
                        if (
                          this.resultGetDoc.document.pdfUrlMachine &&
                          this.resultGetDoc.document.pdfUrlMachine
                        ) {
                          this.pdfUrlMachine = this.resultGetDoc.document.pdfUrlMachine;
                          this.showDrawerPoglad();
                          clearInterval(this.timerId);
                        }
                      }
                    }
                  );
                }, 5000);
              }
            }
          }
        );

      } else {
        this.loading = false;
        this.$message.info(this.$t("Nie znaleziono pliku!"));
      }
    },
    getpdf(classCanvas) {
      this.loading = false;
      this.prew_doc_spinner = true;

      var url = this.pdfUrlMachine;


      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
      var loadingTask = pdfjsLib.getDocument(url);
      loadingTask.promise.then(
        (pdf) => {
          try {
            this.countPages = pdf.numPages;
            if (1 <= this.currentPage && this.countPages >= this.currentPage)
              pdf.getPage(this.currentPage).then((page) => {
                var scale = 2.0;
                var viewport = page.getViewport({ scale: scale });
                var canvas = document.getElementById(classCanvas);
                var context = canvas.getContext("2d");
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                var renderContext = {
                  canvasContext: context,
                  viewport: viewport,
                };
                var renderTask = page.render(renderContext);
                renderTask.promise.then(() => {
                  canvas.style.display = "unset";
                });
              });
            this.prew_doc_spinner = false;
          } catch {
            this.prew_doc = true;
            this.prew_doc_spinner = false;
          }
        },
        (reason) => {
          this.prew_doc = true;
          this.prew_doc_spinner = false;
          console.error(reason);
        }
      );
    },
    goSteps(record) {
      this.changeSpinning(true);

      if (!record) {
        this.sale_record = {};
        this.current = 0;
        this.visibleSteps = true;
        this.changeSpinning(false);
        BX24.fitWindow();
      } else {
        if (!record.status || record.status == "Nowy") {
          record.status = "Nowy";
          this.current = 0;
        } else if (record.status == "Oczekujacy") {
          this.current = 1;
        } else if (
          record.status == "Zaakceptowany" ||
          record.status == "Czesciowo Splacony"
        ) {
          this.current = 2;
        } else if (record.status == "Splacony") {
          this.current = 3;
        }
        this.disableFromResponsible = false;
        let first_stage = this.current == 0 ? true : false;
        let id_file = record.ID;
        this.$emit("updateCompanyList");
        getSalesAllStage(first_stage, id_file)
          .done((data) => {
            this.$message.info(this.$t("Download complete!"));
            let item = data == "" ? {} : JSON.parse(data);
            Object.assign(record, item);
          })
          .fail((e) => {
            console.err(e);
            this.$message.error(this.$t("Error loading document"));
          })
          .always(() => {
            BX24.callMethod("profile", {}, (res) => {
              this.profile = res.data();
              this.sale_record = record;
              if (record.crm_user == undefined || record.crm_user == true) {
                this.disableFromResponsible = false;
              } else if (
                record.crm_user == false &&
                this.responsible.indexOf(res.answer.result.ID + "") != -1 &&
                this.current != 0 &&
                res.answer.result.ADMIN != true
              ) {
                this.current = 0;
                this.disableFromResponsible = true;
              }
              this.visibleSteps = true;
              this.changeSpinning(false);
              BX24.fitWindow();
            });
          });
      }
    },
    showSteps() {

      this.changeSpinning(true);
      this.visibleSteps = true;

      BX24.fitWindow();
      this.changeSpinning(false);
    },
    onClose(element) {
      this.visibleSteps = false;
      if (element) {
        this.updateStatisticNumber(element);
        if (element.element) element.element["key"] = ++this.lastkey;
        if (element.element) this.dataSource.unshift(element.element);
      }
      this.resize();
    },
    changeSpinning(val) {
      this.$emit("changeSpinning", val);
    },
    sortField(a, b, toTheValue) {
      if (toTheValue) {
        a = toTheValue(a);
        b = toTheValue(b);
      }
      if (a > b) {
        return 1;
      } else if (a < b) {
        return -1;
      }
      return 0;
    },
    checkResponsibleUser() {
      this.checkResponsible = Boolean(this.responsible.find(el => (el == this.userProfile.ID) ));
    },
    async setAllInvoices() {
      let resp_getInvoices = await getAllCreatingInvoice();
      if (resp_getInvoices.ok) {
        let vals = await resp_getInvoices.json();

        this.dataSource = vals.all_invoice;
        for (var i in this.dataSource) {
          this.dataSource[i]["key"] = i;
        }
        this.lastkey = i;
        delete vals.all_invoice;
        this.setStatistic({ vals, statusList: this.statusList });
      } else {
        this.$message.error(this.$t("Error loading files"));
      }
      this.changeSpinning(false);
      this.resize();
    },
    resize() {
      setTimeout(
        () =>
          BX24.resizeWindow(
            parseInt($("body #root_block").css("width")),
            parseInt($("body #root_block").css("height"))
          ),
        100
      );
    },
  },
  async mounted() {
    if (this.checkMedia == true) {
      this.goSteps();
    } else if (this.checkMediaInvoice == true) {
      this.goSteps(this.invoiceMedia);
    }


    BX24.callMethod("user.admin", {}, (result) => {
      if (result.error()) console.error(result.error());
      else {
        var isAdmin = result.data();

        BX24.callMethod("user.current", {}, (result) => {
          if (result.error()) console.error(result.error());
          else {
            var userCurrent = result.data();
            this.userProfile = userCurrent;
            this.checkResponsibleUser();

            if (isAdmin == true) {
              this.addnew = 1;
              this.onlyAdm = 1;
            } else {
              if (
                this.user_setup.responsibleSpredz.includes(userCurrent.ID) ||
                this.user_setup.responsibleAll.includes(userCurrent.ID)
              ) {
                this.addnew = 1;
              }
            }

          }
        });
      }
    });

    this.controlTableColumns.plainOptions = this.tableColumns.all
      .map((x) => x.title)
      .sort();

    let auth = BX24.getAuth();
    this.domain = auth.domain;

    let userOption = BX24.userOption.get("userTableColumnsSales");

    let adminOption = BX24.appOption.get("adminTableColumnsSales");
    if (userOption) {
      this.controlTableColumns.checkedList = JSON.parse(userOption);
    } else if (adminOption) {
      this.controlTableColumns.checkedList = JSON.parse(adminOption);
    }
    this.updateSelectedColumns();

    BX24.callMethod("crm.deal.list", {}, (result) => {
      // eslint-disable-next-line
      if (result.error()) {}
      else {
        this.DEAL = this.DEAL.concat(result.data());
        if (result.more()) result.next();
      }
    });
    if (this.placementDealID === false && this.placementCompanyID === false) {
      await this.setAllInvoices();
    } else {
      if (this.placementDealID !== false) {
        this.handleSearch({ project: [this.placementDealID] });
      } else if (this.placementCompanyID !== false) {
        this.handleSearch({ kontragent: this.placementCompanyID });
      }
    }
  },
};
</script>

<style scoped>
.table-operations {
  margin-top: 10px 0;
  display: flex;
  justify-content: space-around;
}

.table-operations > div {
  margin-right: 10px;
}
</style>
